export const chatEn = {
  assignInfo: (who: string[], by: string) =>
    `“${who.join('”, “')}” was assigned to this task by user “${by}”`,
  assignInfoPrefix: (users: number): string => (users > 1 ? 'Users' : 'User'),
  assignInfoInfix: (users: number): string =>
    users > 1
      ? 'were assigned to this task by user'
      : 'was assigned to this task by user',
  moveInfo: (who: string, from: string, to: string) =>
    `Task moved by ${who} from ${from} to ${to}`,
  moveInfoPrefix: 'Task moved by',
  moveInfoInfix1: 'from',
  moveInfoInfix2: 'to',
  gtdInfo: (who: string, done: boolean) =>
    `User ${who} marked task ${done ? 'done' : 'not done'}`,
  gtdInfoPrefix: 'User',
  gtdInfoSuffix: (done: boolean) => `marked task ${done ? 'done' : 'not done'}`,
  assignInfoPart: 'was assigned to this task by user',
  assignInfoPartMulti: 'were assigned to this task by user',
  assigned: 'Assigned',
  assignedBy: 'Assigned by',
  responsible: 'Responsible',
  taskTab: 'Info / Log',
  taskInfo: 'Task Info',
  noBoard: 'Task with no board',
  moveToBoard: 'Move to board',
  addSticker: 'Add sticker',
  privateHint: 'Private task, only you can see this task',
  makePublic: 'Make available for your team',
  changeLocation: 'Change location',
  privateChatSubscribers:
    'This task is private to you, to add another users' +
    'to this task, make it available to your company',
  privateChatFromPrivateListSubscribers:
    'This task is only available to you ' +
    'and you cannot add participants to it.',
  whoSection: 'Author and assigned users',
  locationSection: 'Location',
  stickerSection: 'Stickers',
  goToTask: 'Go to board',
  availableToTitle: 'Who can see this task',
  taskEventLog: 'Task event log',
  markUnreadHint: 'Mark message unread',
  markImportantHint: 'Mark important',
  replyHint: 'Reply to this message',
  replyCancelHint: 'Cancel replying?',
  editCancelHint: 'Discard changes?',
  editCancelButton: 'Discard',
  emoji: {
    search: 'Search',
    clear: 'Clear',
    notfound: 'No Emoji Found',
    skintext: 'Choose your default skin tone',
    categories: {
      search: 'Search Results',
      recent: 'Frequently Used',
      people: 'Smileys & People',
      nature: 'Animals & Nature',
      foods: 'Food & Drink',
      activity: 'Activity',
      places: 'Travel & Places',
      objects: 'Objects',
      symbols: 'Symbols',
      flags: 'Flags',
      custom: 'Custom'
    },
    categorieslabel: 'Emoji categories',
    skintones: {
      1: 'Default Skin Tone',
      2: 'Light Skin Tone',
      3: 'Medium-Light Skin Tone',
      4: 'Medium Skin Tone',
      5: 'Medium-Dark Skin Tone',
      6: 'Dark Skin Tone'
    }
  },
  attachHint: 'Attach file',
  emojiHint: 'Add emoji',
  sendHint: 'Send message',
  mentionHint: 'Mention user',
  mentionNotFound: (search: string) =>
    `Users not found. Searched by “${search}”`,
  mentionExplain:
    'Mentioned user will be notified even if not participated in task chat',
  settings: 'Settings',
  starredOnTop: 'Starred tasks and chats are always on top',
  unreadOnTop: 'Unread tasks and chats on top of the list',
  privateTasks: 'Private tasks',
  searchInChats: 'Search in all chats',
  taskNotFound: 'Task not found',
  copyLinkOnTask: 'Copy link on task',
  fileUploadFailedTitle: 'File upload failed',
  fileUploadFailedMessage:
    'Some files failed to upload. Retry or cancel sending?',
  fileUploadFailedRetry: 'Retry',
  fileUploadFailedCancel: 'Cancel'
}

export const chatRu: typeof chatEn = {
  assignInfo: (who: string[], by: string) =>
    `Сотрудник${who.length > 1 ? 'и' : ''} “${who.join('”, “')}” назначен${
      who.length > 1 ? 'ы' : ''
    } исполнител${who.length > 1 ? 'ями' : 'ем'} задачи пользователем “${by}”`,
  assignInfoPrefix: (users: number): string =>
    users > 1 ? 'Сотрудники' : 'Сотрудник',
  assignInfoInfix: (users: number): string =>
    users > 1
      ? 'назначены исполнителями задачи пользователем'
      : 'назначен(а) исполнителем задачи пользователем',
  moveInfo: (who: string, from: string, to: string) =>
    `Задача перемещена сотрудником “${who}“ из “${from}“ в “${to}“`,
  moveInfoPrefix: 'Задача перемещена сотрудником',
  moveInfoInfix1: 'из',
  moveInfoInfix2: 'в',
  gtdInfo: (who: string, done: boolean) =>
    `Пользователь “${who}“ отметил(а) задачу ${
      done ? 'выполненной' : 'невыполненной'
    }`,
  gtdInfoPrefix: 'Пользователь',
  gtdInfoSuffix: (done: boolean) =>
    `отметил(а) задачу ${done ? 'выполненной' : 'невыполненной'}`,
  assignInfoPart: 'назначен(а) исполнителем задачи пользователем',
  assignInfoPartMulti: 'назначены исполнителями задачи пользователем',
  assigned: 'Исполнители',
  assignedBy: 'Поручили',
  responsible: 'Ответственный',
  taskTab: 'Инфо / Лог',
  taskInfo: 'Информация по задаче',
  noBoard: 'Задача без доски',
  moveToBoard: 'Перенести в доску',
  addSticker: 'Добавить стикер',
  privateHint: 'Приватная задача, доступна только вам',
  makePublic: 'Сделать доступной для компании',
  changeLocation: 'Изменить расположение',
  privateChatSubscribers:
    'Эта задача доступна только вам, чтобы ' +
    'добавить в неё участников, сделайте её доступной в компании',
  privateChatFromPrivateListSubscribers:
    'Эта задача доступна только вам, ' + 'в нее нельзя добавить участников',
  whoSection: 'Автор и исполнители',
  locationSection: 'Расположение',
  stickerSection: 'Стикеры',
  goToTask: 'Перейти к доске',
  availableToTitle: 'Кто видит задачу',
  markUnreadHint: 'Отметить сообщение непрочитанным',
  markImportantHint: 'Отменить важным',
  taskEventLog: 'Лог событий по задаче',
  replyHint: 'Ответить на это сообщение',
  replyCancelHint: 'Прекратить отвечать на сообщение?',
  editCancelHint: 'Прекратить редактировать сообщение?',
  editCancelButton: 'Прекратить',
  emoji: {
    search: 'Поиск',
    clear: 'Очистить',
    notfound: 'Не найдено',
    skintext: 'Выберите тон по умолчанию',
    categories: {
      search: 'Результаты поиска',
      recent: 'Часто используемые',
      people: 'Смайлики и люди',
      nature: 'Животные и природа',
      foods: 'Еда и напитки',
      activity: 'Физическая активность',
      places: 'Путешествия и места',
      objects: 'Объекты',
      symbols: 'Символы',
      flags: 'Флаги',
      custom: 'Дополнительно'
    },
    categorieslabel: 'Категории смайликов',
    skintones: {
      1: 'Тон по умолчанию',
      2: 'Светлый тон',
      3: 'Средне-светлый тон',
      4: 'Средний тон',
      5: 'Средне-тёмный тон',
      6: 'Тёмный тон'
    }
  },
  attachHint: 'Прикрепить файл',
  emojiHint: 'Добавить смайлик',
  sendHint: 'Отправить сообщение (Enter)',
  mentionHint: 'Упомянуть пользователя',
  mentionNotFound: (search: string) =>
    `Пользователи не найдены. Фильтрация по запросу “${search}”`,
  mentionExplain:
    'Пользователь будет уведомлён о сообщении, в котором он упомянут, ' +
    'даже если он не подписан на чат',
  settings: 'Настройки списка',
  starredOnTop: 'Избранные задачи и чаты всегда сверху',
  unreadOnTop: 'Непрочитанные задачи и чаты вверху',
  privateTasks: 'Приватные задачи',
  searchInChats: 'Поиск по всем чатам',
  taskNotFound: 'Задача не найдена',
  copyLinkOnTask: 'Копировать ссылку',
  fileUploadFailedTitle: 'Ошибка загрузки файлов',
  fileUploadFailedMessage:
    'Не все файлы удалось загрузить. Повторить попытку или отменить отправку?',
  fileUploadFailedRetry: 'Повторить',
  fileUploadFailedCancel: 'Отменить'
}
